import Glide from '@glidejs/glide';

export function setupDateSlider() {
    if (document.querySelector('#date-slider')) {
        let dateSlider = new Glide('#date-slider', {
            perView: 9,
            rewind: false,
            bound: true,
            breakpoints: {
                1000: {
                    perView: 7,
                },
                850: {
                    perView: 8,
                },
                750: {
                    perView: 7,
                },
                650: {
                    perView: 6,
                },
                575: {
                    perView: 5
                },
                500: {
                    perView: 4
                }
            }

        });
        dateSlider.mount();

        document.getElementById('date-slider').addEventListener('click', function(evt) {
            if (evt.target.classList.contains('slider-slide')) {
                document.querySelectorAll('#date-slider .slider-slide').forEach(function(elm) {
                    elm.classList.remove('selected');
                });
                evt.target.classList.add('selected');
            } else {
                return;
            }
        });

        return dateSlider;
    } else {
        return false;
    }
}
